import { setup_ajax, show_login_prompt_if_required } from "./helpers";
setup_ajax();
var topic_item_sidebar_template = require("./../templates/topic-item-home-sidebar.handlebars");
var topic_follow_template = require("./../templates/topic-follow-button.handlebars");

function trackTopicEvent(eventType, sourceSurface, targetUrl) {
  fetch("/api/analytics/track_event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_type: eventType,
      source_surface: sourceSurface,
      target_url: targetUrl,
    }),
    keepalive: true,
  }).catch(function () {});
}

export function is_subscribed_to_topic(my_topics, topic_id) {
  for (let my_topic of my_topics) {
    if (my_topic.id === parseInt(topic_id)) {
      return true;
    }
  }
  return false;
}

export function load_my_topics_left_sidebar_if_required() {
  // Rendered into every .js-my-topics container: the desktop sidebar card
  // and the mobile topics drawer both use this, off a single request.
  const $targets = $(".js-my-topics");
  if (!$targets.length) {
    return;
  }

  $.ajax({
    type: "GET",
    url: "/api/user/topics",
    success: function (my_topics) {
      $targets.empty();
      for (let topic of my_topics) {
        const html = topic_item_sidebar_template(topic);
        $targets.append(html);
      }
      $(".js-my-topics-empty").toggle(my_topics.length === 0);
    },
  });
}

$(function () {
  $("#popular-topics-cog").on("click", function () {
    show_login_prompt_if_required("follow_topic");
  });

  load_my_topics_left_sidebar_if_required();

  const $popular_targets = $(".js-popular-topics");
  if ($popular_targets.length) {
    $.ajax({
      type: "GET",
      url: "/api/topics/popular",
      success: function (popular_topics) {
        let count = 0;
        for (let topic of popular_topics) {
          const html = topic_item_sidebar_template(topic);
          $popular_targets.append(html);
          count += 1;
          if (count === 30) {
            break;
          }
        }

        if ($("#topic-follow-button-holder").length) {
          const page_topic_id = $("#topic-follow-button-holder").data(
            "topic-id"
          );
          const html = topic_follow_template({
            following: false,
            id: page_topic_id,
          });
          $("#topic-follow-button-holder").html(html);
        }
      },
    });
  }

  $(document).on("click", ".js-topic-sidebar-link", function () {
    trackTopicEvent("topic_sidebar_click", "sidebar_topics", this.href);
  });
});
